//core
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

//styles
import { useStyles } from "./styles";

//hooks
import { useSubAffDealsV2 } from "../../../../../store/admin/subAffDealsV2/useSubAffDealsV2";

interface IDeleteConditionProps {
  id: number | string;
  setToggleModal: (arg: boolean) => void,
}

const DeleteDeal: React.FC<IDeleteConditionProps> = ({
  id,
  setToggleModal,
}): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();

  const { deleteCondition } = useSubAffDealsV2();

  const handleCancel = useCallback(() => {
    setToggleModal(false);
  }, [setToggleModal]);

  const handleDelete = useCallback(() => {
    deleteCondition({id: id});
    setToggleModal(false);
  }, [id]);

  return (
    <Box>
      <Typography className={styles.title} variant="h6">
        {t("admin.sub_aff_deals.modals.delete.title")}
      </Typography>
      <Typography className={styles.description} variant="body2">
        {t("admin.sub_aff_deals.modals.delete.description")}
      </Typography>
      <Box className={styles.footer}>
        <Button
          className={styles.button}
          variant="contained"
          color="secondary"
          onClick={handleDelete}
        >
          {t("common.buttons.delete")}
        </Button>
        <Button
          className={styles.button}
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
        >
          {t("common.buttons.cancel")}
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteDeal;
